import { useContext } from 'react';
import { AuthenticationContext, type AuthenticationContextValue } from '@/providers/authContext';

export function useAuth(): AuthenticationContextValue {
  const authenticationContext = useContext(AuthenticationContext);
  if (authenticationContext === null) {
    throw new Error('useAuth must be used within an AuthProvider.');
  }
  return authenticationContext;
}
